import React from "react";
import { Shimmer } from "./shimmer";
export const ColumnShimmerX5 = ({ amountOfColumns }) => (React.createElement("div", { className: "flex flex-row w-full justify-between gap-4" }, Array.from({ length: amountOfColumns || 5 }).map((_, i) => (React.createElement("div", { key: i, className: `flex flex-col gap-3 w-1/${amountOfColumns || 5}` },
    React.createElement(Shimmer, { height: "10em" }),
    React.createElement(Shimmer, { height: "1em" }),
    React.createElement(Shimmer, { height: "1em" }))))));
export const ParagraphShimmer = () => (React.createElement("div", { className: "flex flex-col gap-3" }, [
    [3, 3],
    [2, 2],
    [3, 3],
].map((countArr, idx) => (React.createElement("div", { key: idx, className: "flex flex-row gap-3 items-center" }, Array.from({ length: countArr[0] }).map((_, i) => (React.createElement(Shimmer, { key: i }))))))));
export const AccordionShimmer = () => (React.createElement("div", { className: "flex flex-col gap-3" }, Array.from({ length: 3 }).map((_, i) => (React.createElement("div", { key: i, className: "flex flex-row gap-3 items-center" },
    React.createElement(Shimmer, { width: "85%" }),
    React.createElement(Shimmer, { width: "15%" }))))));
export const ListShimmerX3 = () => (React.createElement("div", { className: "flex flex-col w-full justify-between gap-4" }, Array.from({ length: 3 }).map((_, i) => (React.createElement("div", { key: i, className: "flex flex-row gap-3" },
    React.createElement("div", null,
        React.createElement(Shimmer, { width: "5em", height: "5em" })),
    React.createElement("div", { className: "flex flex-col justify-evenly gap-3 w-full" },
        React.createElement(Shimmer, { height: "1em" }),
        React.createElement(Shimmer, { height: "1em" }),
        React.createElement(Shimmer, { height: "1em" })))))));
export const ProductViewShimmer = () => (React.createElement("div", { className: "flex flex-col w-full" },
    React.createElement("div", { className: "flex flex-col lg:flex-row items-center gap-20" },
        React.createElement("div", null,
            React.createElement(Shimmer, { width: "20em", height: "20em" })),
        React.createElement("div", { className: "flex flex-col justify-start gap-6 w-full" },
            React.createElement("div", { className: "mb-3" },
                React.createElement(Shimmer, { height: "2em" })),
            React.createElement("div", { className: "flex flex-col w-2/3 gap-3" },
                React.createElement(Shimmer, { height: "1em" }),
                React.createElement(Shimmer, { height: "1em" })),
            React.createElement("div", { className: "w-1/3" },
                React.createElement(Shimmer, { height: "2em" }))))));
export const CarouselShimmer = () => (React.createElement("div", { className: "flex flex-row w-full justify-between gap-4" }, ["", "hidden sm:flex", "hidden md:flex", "hidden lg:flex"].map((className, i) => (React.createElement("div", { key: i, className: `flex flex-col gap-3 ${className}` },
    React.createElement(Shimmer, { width: "15em", height: "15em" }),
    React.createElement(Shimmer, { height: "1em" }))))));
export const CheckListShimmer = () => (React.createElement("div", { className: "flex flex-col gap-5" }, [{ width: "80%" }, { width: "100%" }].map((item, idx) => (React.createElement("div", { key: idx, className: "flex flex-row gap-2 items-center" },
    React.createElement("div", { className: "w-1/6" },
        React.createElement(Shimmer, { width: "20px" })),
    React.createElement("div", { className: "w-5/6" },
        React.createElement(Shimmer, { width: item.width })))))));
export const ProductListShimmerX5 = () => {
    const Block = (props) => (React.createElement("div", { className: `flex flex-col gap-3 w-[200px] ${props.className}` },
        React.createElement(Shimmer, { height: "12em" }),
        React.createElement(Shimmer, { height: "1em" }),
        React.createElement(Shimmer, { height: "1em" })));
    return (React.createElement("div", { className: "flex flex-row w-full flex-wrap justify-center sm:justify-start gap-4" }, Array.from({ length: 9 }).map((_, i) => {
        let className = "";
        if (i === 4)
            className = "hidden sm:flex";
        if (i === 5 || i === 6)
            className = "hidden md:flex";
        if (i === 7 || i === 8)
            className = "hidden lg:flex";
        return React.createElement(Block, { key: i, className: className });
    })));
};
export const ProductSearchShimmer = () => {
    const Block = (props) => (React.createElement("div", { className: `flex flex-col gap-3 w-[40%] ${props.className}` },
        React.createElement(Shimmer, { height: "12em" }),
        React.createElement(Shimmer, { height: "1em" }),
        React.createElement(Shimmer, { height: "1em" })));
    return (React.createElement("div", { className: "flex flex-row w-full flex-wrap justify-evenly gap-6" },
        React.createElement(Block, null),
        React.createElement(Block, null)));
};
